import { getActivityHistorySelectedActionId } from '@store/reducers/manager/activityHistory/selectors'
import type React from 'react'
import { useSelector } from 'react-redux'

import { clsJoin } from '@/utils'
import { formatTime, getActionTypeName } from '../../../../../../helper'
import { ChangesItemMenu } from './components/ChangesItemMenu'
import css from './styles.module.css'

type Props = {
  id: number
  createdAt: string
  type: string
  onClick: (id: number) => void
  onRestore: (id: number) => void
}

export const ChangesItem: React.FC<Props> = ({
  id,
  type,
  createdAt,
  onClick,
  onRestore,
}) => {
  const withName = true

  const selectedActionId = useSelector(getActivityHistorySelectedActionId)

  const selected = selectedActionId === id

  const handleOnClick = () => {
    onClick(id)
  }

  return (
    <div className={clsJoin(css.changes_item, selected && css.active)}>
      <div
        className={clsJoin(
          css.changes_text_wrap,
          !withName && css.cursor_default
        )}
        onClick={handleOnClick}
      >
        <span className={css.changes_name}>
          {getActionTypeName(type) || type}
        </span>
        <span className={css.changes_time}>{formatTime(createdAt)}</span>
      </div>

      {withName && (
        <ChangesItemMenu
          buttonCn={css.dropdown_menu}
          onRestore={() => onRestore(id)}
        />
      )}
    </div>
  )
}
